export const API_CARRIER_ORDER_LIKE = '/like';
export const API_CARRIER_ORDER_RECOMMEND = '/recommend';
export const API_ORDER_MATCH_SEARCH_CARD = '/v1/order-match-search-card/active';
export const API_RECOMMENDS_ORDER_PAGE = '/all-recommend/page';
export const API_RECOMMENDS_ORDER_COUNT = '/all-recommend/count';
